import React from "react";
import {
  Tag,
  TagProps,
  TagLeftIcon,
  TagRightIcon,
  TagLabel,
} from "@chakra-ui/react";

interface IIconTag extends TagProps {
  // The Icon passed in should be an icon from 'react-icons/fa' but their
  // internal icon type isn't exported, and cannot by accessed.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  icon?: any;
  text: string | JSX.Element;
  iconOrientation?: "left" | "right";
}

/**
 * A wrapper around the Chakra Tag component that includes an Icon and some
 * base styling. This is meant to be extended to other components to specify
 * some of these values more directly.
 * @param {any} icon The icon being displayed. SHOULD BE FROM REACT-ICONS
 * @param {string} text The text to be displayed in the tag
 * @param {'left'|'right'} iconOrientation Default to 'left', controls where
 * the icon is rendered relative to the text.
 */
export function IconTag({
  icon,
  text,
  iconOrientation = "left",
  ...delegated
}: IIconTag) {
  let tagText = text;
  if (text && typeof text == "string") {
    tagText = text?.length > 0 ? <TagLabel>{text}</TagLabel> : "";
  }
  let tagContents = <>{tagText}</>;
  if (!icon) {
    return <TagBase {...delegated}>{tagContents}</TagBase>;
  }

  if (iconOrientation === "left") {
    tagContents = (
      <>
        {tagText}
        <TagRightIcon as={icon} marginLeft="4px" />
      </>
    );
  } else {
    tagContents = (
      <>
        <TagLeftIcon as={icon} marginRight="4px" />
        {tagText}
      </>
    );
  }

  return <TagBase {...delegated}>{tagContents}</TagBase>;
}

function TagBase({
  children,
  ...delegated
}: React.PropsWithChildren<TagProps>) {
  return (
    <Tag size="md" borderRadius="full" {...delegated}>
      {children}
    </Tag>
  );
}
